import React, { useEffect, useRef, useState } from "react"
import $ from "jquery"
window.$ = window.jQuery = $
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
// import "datatables.net-dt";
import "datatables.net-bs4"
import axios from "axios"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import {
  deleteUser,
  downloadUser,
  EditUser,
  editUserStatus,
} from "services/ApiService"
import { toast, ToastContainer } from "react-toastify"
import Swal from "sweetalert2"

const ResultDataTable = ({ apiURL, idName, selectedData }) => {
  const tableRef = useRef(null)
  const token = localStorage.getItem("authorizedToken")
  const [tableData, setTableData] = useState([])
  console.log("selectedData", selectedData);

  const fetchData = (dataTablesData, callback) => {
    $("#customLoader").show()
    const reqObj = {
      ...dataTablesData,
      userId: selectedData?.userId ? selectedData?.userId : selectedData?.id
    }
    axios
      .post(apiURL, reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        const res = response.data
        $("#customLoader").hide()
        callback({
          draw: dataTablesData.draw,
          recordsTotal: res.recordsTotal,
          recordsFiltered: res.recordsFiltered,
          data: res.data,
        })
        setTableData(res.data)
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          console.error("Error fetching data:", err)
        }
      })
  }

  useEffect(() => {
    if (!tableRef.current) return;
    if (tableRef.current) {
      const table = $(tableRef.current).DataTable({
        processing: true,
        serverSide: true,
        autoWidth: false,
        ordering: false,
        ajax: fetchData,
        columns: [
          {
            data: "_id",
            title: "Test",
            orderable: false,
            width: "120px", // fixed width
            render: function (data, type, row) {
              return data ? data.substring(0, 8) + "..." : "";
            }
          },
          {
            data: "null",
            title: "Type",
            orderable: false,
            render: function (data, type, row) {
              const label = row?.isPracticeTest ? "Practice" : row?.isExtraTest ? "Control" : "Crowd"
              return `${label}`
            },
          },
          {
            data: "null",
            title: "Date",
            orderable: false,
            render: function (data, type, row) {
              console.log("data", row);
              const date = new Date(row?.startTime)
              const day = String(date.getDate()).padStart(2, "0")
              const month = String(date.getMonth() + 1).padStart(2, "0") // Months are 0-based
              const year = date.getFullYear()
              return `${day}/${month}/${year}`
            },
          },
          {
            data: "null",
            title: "Time",
            orderable: false,
            render: function (data, type, row) {
              console.log("data", row);
              const time = new Date(row?.startTime)
              return `${time?.toLocaleTimeString()}`
            },
          },
          { data: "noOfHits", title: "Hits", orderable: false },
          { data: "cumulativeScore", title: "Cumulative Score", orderable: false },
          {
            data: "null",
            title: "Target Images Hits per Test",
            orderable: false,
            width: "150px",
            render: function (data, type, row) {
              if (Array.isArray(row?.targetImages)) {
                return row?.targetImages?.map(item => {
                  if (item.recieveImage === item.selectImage) return `${item.recieveImage?.charAt(0)}1Ø`;
                  if (item.recieveImage === item.selectImage2) return `${item.recieveImage?.charAt(0)}Ø1`;
                  return `${item.recieveImage?.charAt(0)}ØØ`;
                })
                  .join("  ");
              }
              return "";
            },
          },
          {
            data: "null",
            title: "Binaural Audio",
            orderable: false,
            render: function (data, type, row) {
              if (Array.isArray(row?.targetImages)) {
                return row?.targetImages?.map(item => {
                  const firstChar = item.recieveImage?.charAt(0)?.toUpperCase()
                  if (firstChar === "S") return `1`;
                  if (firstChar === "O") return `2`;
                  if (firstChar === "A") return `3`;
                  if (firstChar === "C") return `4`;
                  if (firstChar === "L") return `5`;
                  if (firstChar === "F") return `6`;
                  return `${item.recieveImage?.charAt(0)}00`;
                })
                  .join("  "); // or "<br>" for line breaks
              }
              return "";
            },
          },
          {
            data: "null",
            title: "Crowd Size",
            orderable: false,
            render: function (data, type, row) {
              return `
                <div>
                  <span>${Number(row?.nop) - Number(row?.noOfJoinVirtualUser)}</span>
                </div>
              `
            },
          },
          { data: "crowdPerformance", title: "Crowd Hits", orderable: false },
          {
            data: "location",
            title: "Test Location",
            orderable: false,
            render: function (data, type, row) {
              return `
                <div>
                  <span>${row?.location} <br /> ${row?.locationIP}</span>
                </div>
              `
            },
          },
        ],
        destroy: true,

        createdRow: row => {
          // Apply inline style to center text in each cell
          $("td", row).css("text-align", "center")
        },
        headerCallback: thead => {
          // Apply inline style to center text and set background color in header cells
          $("th", thead).css({
            "text-align": "center",
            "background-color": "#f2f2f2", // Change this to your desired color
          })
        },
      })

      $(tableRef.current).closest("div.dt-container").find("div.dt-search input").hide()
      $(tableRef.current).closest("div.dt-container").find("div.dt-search label").hide()
      return () => {
        table.destroy(true); // clean up properly
      };
    }
  }, [idName])
 
  return (
    <div>
      <ToastContainer />

      <div className="table-responsive">
        <table
          id={`dataTable${idName} `}
          ref={tableRef}
          className="table table-hover table-bordered my-3"
          style={{ width: "100%", fontSize: 14, color: "#858D9D" }}
        ></table>
      </div>

    </div>
  )
}
export default ResultDataTable
